module.exports = __webpack_public_path__ + "img/807.924edff2.png";